// Centralized content for Digibis Digital site

export const BRAND = {
  name: "Digibis Digital",
  short: "Digibis",
  tagline: "We don't do marketing. We build scalable revenue systems.",
  phone: "+91-94140-84242",
  phoneHref: "tel:+919414084242",
  whatsapp: "919414084242",
  email: "bizdigiindia@gmail.com",
  location: "Pan India",
};

// ============================================================
// SOCIAL MEDIA LINKS — shown in the footer
// Update any URL here and the footer icon instantly points to it.
// Leave a URL as "" (empty string) to hide that icon.
// ============================================================
export const SOCIAL_LINKS = [
  {
    name: "Instagram",
    url: "https://www.instagram.com/digibis_digital/",
    icon: "instagram",
  },
  {
    name: "Facebook",
    url: "https://www.facebook.com/profile.php?id=61580633792938",
    icon: "facebook",
  },
  {
    name: "LinkedIn",
    url: "https://www.linkedin.com/company/digibis-digital-agency/?viewAsMember=true",
    icon: "linkedin",
  },
  {
    name: "YouTube",
    url: "https://youtube.com/@digibisdigital?si=paH9XQjI_uQvWCnr",
    icon: "youtube",
  },
  {
    name: "X (Twitter)",
    url: "https://x.com/DigibisD",
    icon: "twitter",
  },
  {
    name: "WhatsApp",
    url: "https://wa.me/919414084242",
    icon: "whatsapp",
  },
];

export const NAV_LINKS = [
  { label: "Niches", href: "#niches" },
  { label: "Services", href: "#services" },
  { label: "Case Studies", href: "#case-studies" },
  { label: "Process", href: "#process" },
  { label: "Reviews", href: "#testimonials" },
  { label: "Contact", href: "#contact" },
];

export const TRUST_STATS = [
  { value: "100+", label: "Campaigns Managed", suffix: "" },
  { value: "₹5Cr+", label: "Revenue Generated", suffix: "" },
  { value: "Pan India", label: "Clients Served", suffix: "" },
];

export const NICHES = [
  {
    id: "real-estate",
    name: "Real Estate",
    eyebrow: "01 / Niche",
    headline: "High-intent buyer leads for builders, realtors & developers.",
    points: [
      "Lead generation campaigns",
      "High-quality buyer leads",
      "Site visit funnel systems",
    ],
    result: "More qualified property buyers, lower CPL.",
    image:
      "https://images.unsplash.com/photo-1771466883495-a65f9aedf39a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODR8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBsdXh1cnklMjByZWFsJTIwZXN0YXRlJTIwYnVpbGRpbmclMjBmYWNhZGV8ZW58MHx8fHwxNzc3OTE1MzkzfDA&ixlib=rb-4.1.0&q=85",
    span: "md:col-span-7",
  },
  {
    id: "lifestyle",
    name: "Lifestyle",
    eyebrow: "02 / Niche",
    headline: "Premium positioning for luxury, personal & hospitality brands.",
    points: [
      "Brand positioning & narrative",
      "Content + ads strategy",
      "Premium audience targeting",
    ],
    result: "Attract high-value customers who pay premium prices.",
    image:
      "https://images.unsplash.com/photo-1620061836977-52f84a8f6b91?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwyfHxnb2xkJTIwYWJzdHJhY3QlMjB0ZXh0dXJlJTIwcGF0dGVybnxlbnwwfHx8fDE3Nzc5MTU0MDd8MA&ixlib=rb-4.1.0&q=85",
    span: "md:col-span-5",
  },
  {
    id: "education",
    name: "Education",
    eyebrow: "03 / Niche",
    headline: "Predictable enrollments for coaching, courses & EdTech.",
    points: [
      "Course sales funnels",
      "Webinar funnels",
      "Lead nurturing systems",
    ],
    result: "More enrollments, lower cost per student.",
    image:
      "https://images.unsplash.com/photo-1758611974775-39e307bc3da9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHw0fHxlZHVjYXRpb24lMjBvbmxpbmUlMjBsZWFybmluZyUyMGxhcHRvcCUyMG1vZGVybnxlbnwwfHx8fDE3Nzc5MTU0MDd8MA&ixlib=rb-4.1.0&q=85",
    span: "md:col-span-12",
  },
];

export const SERVICES = [
  {
    id: "paid-ads",
    number: "01",
    name: "Performance Marketing",
    subtitle: "Meta + Google Ads",
    points: [
      "Advanced audience targeting",
      "Funnel-based ad strategy",
      "A/B testing creatives",
      "Daily optimization",
    ],
    result: "Lower CPL + higher ROI",
  },
  {
    id: "funnels",
    number: "02",
    name: "Funnel & Landing Pages",
    subtitle: "Conversion systems",
    points: [
      "Sales-driven landing pages",
      "Lead capture automation",
      "Conversion optimization",
    ],
    result: "More conversions from the same traffic",
  },
  {
    id: "content",
    number: "03",
    name: "Content Creation",
    subtitle: "Reels + Ad Creatives",
    points: [
      "Script writing",
      "Hooks & storytelling",
      "Editing & post-production",
    ],
    result: "High engagement + better ad results",
  },
  {
    id: "social",
    number: "04",
    name: "Social Media Growth",
    subtitle: "Organic visibility",
    points: [
      "Content strategy",
      "Branding & identity",
      "Consistent posting",
    ],
    result: "Compounding organic visibility",
  },
  {
    id: "seo",
    number: "05",
    name: "Search Engine Optimization",
    subtitle: "Long-term compounding traffic",
    points: [
      "Keyword strategy",
      "Technical SEO",
      "On-page optimization",
    ],
    result: "Durable pipeline of free traffic",
  },
];

export const WHY_POINTS = [
  {
    title: "ROI-first approach",
    desc: "Every rupee is tied to a KPI. If it doesn't move revenue, we kill it.",
  },
  {
    title: "Niche-focused strategies",
    desc: "Deep playbooks for real estate, lifestyle & education — not a generic agency.",
  },
  {
    title: "Performance + creative",
    desc: "Numbers-obsessed media buyers paired with scroll-stopping creative teams.",
  },
  {
    title: "Fast execution",
    desc: "Campaigns live within days, not weeks. Momentum compounds.",
  },
  {
    title: "Transparent reporting",
    desc: "Real-time dashboards. No vanity metrics. You always know where you stand.",
  },
];

export const CASE_STUDIES = [
  {
    id: "cs-1",
    category: "Real Estate Developer",
    tagColor: "bg-[#E3A21A]/10 text-[#E3A21A] border-[#E3A21A]/30",
    headline: "450+ qualified leads in 45 days",
    metrics: [
      { big: "450+", label: "leads in 45 days" },
      { big: "38%", label: "lower cost per lead" },
      { big: "3×", label: "site visits" },
    ],
    summary:
      "Geo-fenced Meta + Google campaigns paired with a high-intent site-visit funnel.",
  },
  {
    id: "cs-2",
    category: "Realtor",
    tagColor: "bg-[#E3A21A]/10 text-[#E3A21A] border-[#E3A21A]/30",
    headline: "120+ qualified buyers, closed high-ticket deals",
    metrics: [
      { big: "120+", label: "qualified buyers" },
      { big: "7", label: "high-ticket closures" },
      { big: "₹11Cr", label: "property moved" },
    ],
    summary:
      "Buyer-intent targeting + voice-note WhatsApp nurture that booked site visits on autopilot.",
  },
  {
    id: "cs-3",
    category: "Lifestyle Brand",
    tagColor: "bg-[#E3A21A]/10 text-[#E3A21A] border-[#E3A21A]/30",
    headline: "4× revenue growth with premium positioning",
    metrics: [
      { big: "4×", label: "revenue growth" },
      { big: "2.8×", label: "AOV increase" },
      { big: "68%", label: "repeat customers" },
    ],
    summary:
      "Rebuilt brand narrative + creator-led UGC ads that attracted a higher-paying audience.",
  },
  {
    id: "cs-4",
    category: "Coaching Institute",
    tagColor: "bg-[#E3A21A]/10 text-[#E3A21A] border-[#E3A21A]/30",
    headline: "600+ student leads in 30 days",
    metrics: [
      { big: "600+", label: "leads in 30 days" },
      { big: "3×", label: "enrollments" },
      { big: "₹94", label: "avg. CPL" },
    ],
    summary:
      "Parent + student dual-funnel with demo-class booking flow and daily creative refreshes.",
  },
  {
    id: "cs-5",
    category: "Online Course Creator",
    tagColor: "bg-[#E3A21A]/10 text-[#E3A21A] border-[#E3A21A]/30",
    headline: "₹12L revenue in 60 days via webinar funnel",
    metrics: [
      { big: "₹12L", label: "in 60 days" },
      { big: "5.4×", label: "ROAS" },
      { big: "38%", label: "webinar show-up rate" },
    ],
    summary:
      "Evergreen webinar funnel + retargeting stack that converted cold traffic into cart.",
  },
  {
    id: "cs-6",
    category: "Local Business",
    tagColor: "bg-[#E3A21A]/10 text-[#E3A21A] border-[#E3A21A]/30",
    headline: "8× ROI on ad spend, sustained",
    metrics: [
      { big: "8×", label: "return on ad spend" },
      { big: "62%", label: "lower cost per booking" },
      { big: "90d", label: "to break-even then profit" },
    ],
    summary:
      "Hyperlocal Meta + Google ads backed by a single, obsession-polished landing page.",
  },
];

export const TESTIMONIALS = [
  {
    quote:
      "Digibis helped us run a focused digital campaign that brought real, high-intent enquiries. The team understood our market and delivered measurable results.",
    name: "LIC — Life Insurance Corporation",
    role: "Insurance · Pan India",
  },
  {
    quote:
      "Our showroom footfall grew noticeably within weeks. The lead quality and cost per walk-in dropped — exactly what we were looking for.",
    name: "Pushpa Honda",
    role: "Automotive Dealership",
  },
  {
    quote:
      "Enrollments went up significantly in a single admissions cycle. The webinar + lead nurture funnel they built converts students at a cost we didn't think was possible.",
    name: "Synthesis",
    role: "JEE / NEET Coaching Institute",
  },
  {
    quote:
      "Digibis gave our brand a premium digital identity. The creative strategy positioned us exactly where we wanted — and the footfall followed.",
    name: "Coffeio",
    role: "Hospitality & Cafe Brand",
  },
  {
    quote:
      "We needed quality bookings, not noise. Their ads and landing pages consistently delivered serious buyers asking for real quotes.",
    name: "youdrive",
    role: "Luxury Automotive",
  },
  {
    quote:
      "Finally an agency that focuses on ROI, not vanity metrics. Transparent reporting and fast execution — highly recommended.",
    name: "Premium Developer",
    role: "Real Estate",
  },
  {
    quote:
      "Their funnel system actually converts — cold traffic to paying customer, end-to-end. We scaled our monthly revenue without scaling our headaches.",
    name: "Course Creator",
    role: "EdTech / Online Courses",
  },
  {
    quote:
      "Professional, strategic, and result-oriented. The team feels like an in-house growth department, not an external vendor.",
    name: "D2C Lifestyle Brand",
    role: "Lifestyle",
  },
];

// ============================================================
// CLIENT LOGOS — shown in the running-line (marquee) section
// ------------------------------------------------------------
// 83 client logos live in /app/frontend/public/clients/ (1.png … 83.png).
// To rename a client or change the display label shown in the tooltip /
// alt-tag, simply edit the `name` field for the corresponding entry below.
// Leave `logo: null` on any entry if you want a styled text-pill instead.
// ============================================================
export const CLIENTS = Array.from({ length: 83 }, (_, i) => ({
  name: `Client ${String(i + 1).padStart(2, "0")}`,
  logo: `/clients/${i + 1}.png`,
}));

export const PROCESS_STEPS = [
  {
    n: "01",
    title: "Research & Strategy",
    desc: "Deep audit of your business, market, offer, and existing data. We build the revenue thesis before spending a rupee.",
  },
  {
    n: "02",
    title: "Funnel Setup",
    desc: "Landing pages, lead capture, automations, CRM wiring. The system that turns clicks into qualified conversations.",
  },
  {
    n: "03",
    title: "Ads + Content Execution",
    desc: "Creative engine running weekly. Meta + Google campaigns optimized daily against CPL, CAC and ROAS.",
  },
  {
    n: "04",
    title: "Scaling",
    desc: "Once unit economics work, we scale budget, expand audiences, and compound winning creatives.",
  },
];
